export default __webpack_public_path__ + "static/media/adhoc-meeting.caddcdb2.svg";